export default {
  fields: {
    receiverName: "收货人姓名：",
    phone: "联系手机：",
    address: "收货地址：",
    quantity: "数量：",
    time: "时间：",
  },
  common: {
    empty: "暂无数据",
  },
};
